module.exports = __webpack_public_path__ + "img/tenant-hero.7693afd4.svg";